export function onSubmitionMfe(deps) {
  return async (data, callback) => {
    const { person, peopleRegister } = deps
    person.saveOnState(data)
    await peopleRegister.savePerson(data)
    callback()
  }
}